<template>
  <div v-if="content.show">
    <p class="head-text">你想从事的第<span>{{content.no}}</span>个职业<span class="career-name">{{content.careerName}}</span>,请猜猜它的霍兰德代码</p>
    <ul class="career-box">
      <li v-for="(item,index) in code" class="li">
      <div  class="career-list" >
        <span class="career-code" :class="['background'+[index+1],selected[index]==1?'active':'',selected[index]==2?'gray':'']" @click="selectCode(item.code,index)">{{item.code}}</span>
        <span class="career-text">{{item.text}}</span>
        </div>     
        <div class="text-str">{{textStr[index]}}</div>
      </li>
    </ul>
    <p class="head-text">从上面6个霍兰德代码中，选3个依次填到下面3个格子中</p>
    <ul class="fill-box">
      <li class="fill-list" v-for="(item,index) in newCode">
        <span class="fill-text">第{{index+1}}位</span>
        <span class="fill-code" :class="selected[item.no]==2?'background'+[item.no+1]:'disabled'" @click="fillCode(index)">{{item.value}}
          <i class="iconfont icon-close icon-style"
          v-if="newCode[index].value!='填入'"
          @click="removeCode(item,index)" slot="reference" title="取消"></i>
        </span>
      </li>
    </ul>
    <button class="default-btn medium-btn" :class="show?'half-opacity':''" @click="showRightAnswer">查看正确答案</button>
    <div v-if="showAnswer" class="right-answer">
      <p class="head-text">正确的霍兰德代码为</p>
      <div class="right-code">
        <span v-for="(item,index) in hollandPre" :class="'background'+[item.no]">{{item.code}}</span>
      </div>
    </div>
  </div>
</template>
<!--多答案-->
<script>
  import axios from 'axios';
  import qs from 'qs';
export default {
  props:{
    content:Object
  },
  data(){
    return{
      code:[{code:'R',text:'现实型'},{code:'I',text:'研究型'},{code:'A',text:'艺术型'},{code:'S',text:'社会型'},{code:'E',text:'企业型'},{code:'C',text:'传统型'}],  // 所有的霍兰德类型可选项
      selected:[0,0,0,0,0,0],  //霍兰德类型代码的当前状态
      newCode:[{no:6,value:'填入'},{no:6,value:'填入'},{no:6,value:'填入'}], //选中的霍兰德码
      current:{},  //当前选中的霍兰德码
      hollandPre:[],
      show:true, //按钮的透明度显示
      showAnswer:false,  //正确答案的内容
      textStr:['（喜爱具体明确、需要动手操作的工作环境。通常情绪稳定，忍耐力强。喜欢用实际行动代替言语表达，重视现在胜于重视未来。诚实、谦和，较不喜欢需要社交、与人接触的活动。）',
      '(擅长观察事物、分析推理，抽象思维能力强，善思考。个性独立，头脑聪明，有逻辑。富有创造性，喜欢需要动脑的研究工作，较不喜欢领导他人）',
      '（喜欢自由自在，富有创意的工作环境。个性热情，有丰富的想象力和创造力。在工作上乐于独立思考，不喜欢受人支配，对美的事物有敏锐的直觉，喜欢艺术气息浓厚的工作，较不喜欢从事文书处理等方面的传统工作）',
      '（喜欢从事与人接触的活动。个性友善，乐于助人，易相处。有责任感，喜欢和大家一起完成的工作。关心人胜于关心事物，喜欢从事与帮助他人有关的工作，较不喜欢从事机械操作方面的工作）',
      '（喜爱冒险、竞争，通常精力充沛、生活紧凑，个性积极，社交能力强。在工作上表现出强力的野心，追求权力，具有领导才能。做事有较强的目的性，喜欢销售、管理、政治方面的活动，不喜欢花太多时间做科学研究。）',
      '（个性保守谨慎，注意细节，有责任感，做事按部就班，精打细算。喜欢安定，不喜欢改变、创新和冒险。做事仔细、有效率，尽本分，值得信赖。喜欢在别人的领导下工作，乐于配合和服从。喜欢数字计算、文书资料处理方面的工作，较不喜欢从事艺术活动。）']
    }
  },
  methods:{
    setHolland(){
      let arr = this.content.hollandPreThree.split('')
      arr.map((item,index)=>{
        let no=1
        switch(item){
          case 'I':
           no=2
           break
          case 'A':
           no=3
           break
          case 'S':
           no=4
           break
          case 'E':
           no=5
           break
          case 'C':
           no=6
           break
        }
        this.hollandPre.push({no:no,code:item})
      })
    },
    // 选中时改变霍兰德代码样式，0：无操作，1：选中，2：已加入3位码
    selectCode(text,index){
      if(this.selected[index]!=2){
        if(this.selected[index]){
          this.$set(this.selected,index,0)
        }else{
          // 如果之前有选中类型而没有加入到3位码中,移除样式
          this.selected.map((item,zindex)=>{
            if(item==1){
              this.$set(this.selected,zindex,0)
            }
          })
          this.$set(this.selected,index,1)
        }
        this.current.num = index
        this.current.code = text
      }
    },
    // 将选中的霍兰德代码填入空位
    fillCode(index){
      if(this.current.code&&this.newCode[index].value=='填入'){
        this.$set(this.newCode,index,{no:this.current.num,value:this.current.code})
        // 修改霍兰德代码的状态
        this.$set(this.selected,this.current.num,2)
        this.current.code =''
        // 如果正确的霍兰德代码无内容,先获取内容,
        if(this.hollandPre.length==0){
          this.setHolland()
        }else{
        // 有内容做判断,选中的数量与正确的数量一致时,查看正确答案按钮可点击
          let arr = this.selected.filter((item)=>{return item==2})
          if(arr.length == this.hollandPre.length){
            this.show=false
            if(this.showAnswer){
              this.setUserAnswer()
            }

          }
        }

      }
    },
    // 从数据中删除霍兰德代码
    removeCode(item,index){
      this.$set(this.newCode,index,{no:6,value:'填入'})
      // 修改霍兰德代码状态
      if(item.value!='填入'){
        this.$set(this.selected,item.no,0)
      }
      let arr = this.selected.filter((item)=>{return item==2})
       if(arr.length<this.hollandPre.length){
         this.show=true
       }
    },
    showRightAnswer(){
      if(!this.show){
        this.showAnswer=true
        this.setUserAnswer()
      }
    },
    setUserAnswer(){
      let code = ''
      this.newCode.map((item,index)=>{
          if(item.no!=6){
            code+=item.value
          }
      })
      let answer = this.content.no+'$1<'+this.content.careerName+',2<'+this.content.iTotalScore+',3<'+this.content.hollandPreThree+',4<'+code
      if(this.content.no<4){
        answer+='}'
      }
      this.$emit("listenToChildEvent",answer)
    }
  }
}
</script>
<style lang="stylus" scoped>
 
  .head-text
    text-align:center
    width:90%
    margin:auto
    span
      color:#DC6E5A
    .career-name
      font-size:0.36rem
  .career-box
    overflow:hidden
    width:76%
    padding:1% 7%
    margin:0 auto 0.3rem auto
    background-color:#ffffff
    display: flex;
    align-items: flex-start;
    flex-flow: column nowrap;
    justify-content: flex-start;

    input
      border:1px solid #ddd

    .li 
      width:100%
      max-width:100%
      display: grid;
      grid-template-columns: 80px auto;
      align-items: start;
      margin: 8px 0;
    .text-str
      font-size:12px
      color:#3a3c3c

    .career-list
      max-width:12rem
      float:left
      margin: auto;
      
      .career-code
        display:block
        width:1rem
        height:1rem
        margin:0.1rem 0.4rem
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
        font-size:0.56rem
        color:#ffffff
        border-radius:4px
        opacity:0.6
      .career-text
        display:block
        margin:0.1rem auto 0.3rem auto
        text-align:center
      .active
        width:1.1rem
        height:1.1rem
        margin:auto 0.3rem
        opacity:1
      .gray
        width:1rem
        height:1rem
        background-color:#D0D0D0
  .fill-box
    overflow:hidden
    width:85%
    padding:1% 5%
    margin:auto
    background-color:#ffffff
    .fill-list
      float:left
      margin:0.2rem 0.2rem
      position:relative
      .fill-text
        float:left
        width:0.3rem
        text-align:center
      .fill-code
        float:left
        width:1.2rem
        height:1.2rem
        font-size:0.56rem
        border:1px #bbbbbb dashed
        border-radius:4px
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
        color:#ffffff
        .icon-style
          background-color:#ffffff
          border-radius:50%
          color:#DC6E5A
          position:absolute
          right:0
          top:0
          margin-right:-8px
          margin-top:-8px
          height:16px
      .disabled
        background-color:rgba(0,0,0,0.15)
        font-size:0.28rem
  .background1
    background-color:#EC5724
  .background2
    background-color:#00C1C8
  .background3
    background-color:#7FBC41
  .background4
    background-color:#7B67AD
  .background5
    background-color:#FF6C00
  .background6
    background-color:#FFBB18
  .right-answer
    background-color:#ffffff
    padding:0.2rem
    width:90%
    margin:auto
    .right-code
      overflow:hidden
      width:60%
      margin:auto
      span
        float:left
        width:1rem
        height:1rem
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
        color:#ffffff
        border-radius:6px
        font-size:0.56rem
        margin:0.1rem
</style>
